import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaCrown, FaCoins, FaChevronLeft, FaTrophy } from 'react-icons/fa';
import { BiMedal } from 'react-icons/bi';
import BottomBar from "./BottomBar";
import Navbar from "./navbar";
import './Leaderboard.css';

const Leaderboard = () => {
  const [topPlayers, setTopPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [timeframe, setTimeframe] = useState('weekly');
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`https://backend.aubattle.com/api/admin/leaderboard/${timeframe}`);
        setTopPlayers(res.data);
      } catch (error) {
        console.error('Failed to fetch leaderboard:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, [timeframe]);

  const getMedalColor = (position) => {
    switch(position) {
      case 1: return '#FFD700'; // Gold
      case 2: return '#C0C0C0'; // Silver
      case 3: return '#CD7F32'; // Bronze
      default: return '#6B7280'; // Default gray
    }
  };

  return (
    <div className="leaderboard-page dark-theme">
      <Navbar />
      
      <div className="leaderboard-container">
        <div className="leaderboard-header">
          <button 
            className="back-button"
            onClick={() => navigate(-1)}
          >
            <FaChevronLeft className="back-icon" />
            Back
          </button>
          
          <div className="timeframe-selector">
            <button 
              className={`timeframe-btn ${timeframe === 'daily' ? 'active' : ''}`}
              onClick={() => setTimeframe('daily')}
            >
              Daily
            </button>
            <button 
              className={`timeframe-btn ${timeframe === 'weekly' ? 'active' : ''}`}
              onClick={() => setTimeframe('weekly')}
            >
              Weekly
            </button>
            <button 
              className={`timeframe-btn ${timeframe === 'monthly' ? 'active' : ''}`}
              onClick={() => setTimeframe('monthly')}
            >
              Monthly
            </button>
          </div>
          
          <div className="title-section">
            <FaTrophy className="title-icon" />
            <h1>Leaderboard</h1>
          </div>
        </div>

        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Loading leaderboard...</p>
          </div>
        ) : (
          <div className="leaderboard-table">
            <div className="table-header">
              <div className="header-cell rank">Rank</div>
              <div className="header-cell player">Player</div>
              <div className="header-cell winnings">Winnings</div>
            </div>
            
            <div className="table-body">
              {topPlayers.map((player, index) => (
                <div className={`player-row ${index < 3 ? 'top-player' : ''}`} key={player.id}>
                  <div className="cell rank">
                    {index < 3 ? (
                      <FaCrown className="crown-icon" style={{ color: getMedalColor(index + 1) }} />
                    ) : (
                      <BiMedal className="medal-icon" />
                    )}
                    <span>{index + 1}</span>
                  </div>
                  <div className="cell player">
                    <div className="player-avatar">
                      {player.avatar ? (
                        <img src={player.avatar} alt={player.name} />
                      ) : (
                        <div className="avatar-placeholder">{player.name.charAt(0)}</div>
                      )}
                    </div>
                    <span className="player-name">{player.name}</span>
                  </div>
                  <div className="cell winnings">
                    <FaCoins className="coin-icon" />
                    <span>{player.coins_won.toLocaleString()}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      
      <BottomBar />
    </div>
  );
};

export default Leaderboard;